import { IAddTranscriptionToCanvas } from "../interfaces/IAddTranscriptionToCanvas"
import { AddTranscriptionToWordDocument } from '../Word/AddTranscriptionToWordDocument'
import { AddTranscriptionToONNotebook } from "../OneNote/AddTranscriptionToONNotebook";
import { HostAppName } from "../office-js/HostAppSettings";
import { HostAppUtil } from "../office-js/HostAppUtil";

/* Here we are initializing the AddToDocument provider on basis of user's host app
 depending upon whether it is Word or OneNote or any other office app, by default we will set the provider for Word.
 This AddToDocument provider will initialize the appropriate class on basis of host app name which
 will have app specific api implementations for doing Add To Document/Notebook functionality.*/
export const CreateAddToDocumentProvider = (): IAddTranscriptionToCanvas => {
  const hostAppName = HostAppUtil.GetHostAppName();
  switch (hostAppName) {
    case HostAppName.ONENOTE:
      return new AddTranscriptionToONNotebook();
    case HostAppName.WORD:
    default:
      return new AddTranscriptionToWordDocument();
  }
}